import { VCheckbox } from 'vuetify/lib'
import { defaultFun } from '../utils'
import { CHECKBOX } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: CHECKBOX,
    mixins: [ commonMixins ],
    props: {
        field: {
            type: Object,
        },
        value: {
            type: Object,
        }
    },
    data() {
        if (this.value && this.value[this.field.key] === undefined) {
            this.$set(this.value, this.field.key, false)
        }
        return {
            my_value: this.value,
        }
    },
    watch: {
        value(new_val) {
            this.my_value = new_val
        },
        my_value(new_val) {
            this.$emit('input', new_val)
        }
    },
    render(h) {
        const {
            // eslint-disable-next-line 
            slots,scopedSlots,
             key,
             click = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             ...params 
            } = this.field
        return h(VCheckbox, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
             ...params,
             inputValue: this.my_value[key]
            },
            on: {
                click:(e) => {
                    this.my_value[key] = !this.my_value[key]
                    click(e)
                },
                mousedown,
                mouseup,
            }
        })
    }
}